<script>
import appConfig from "@/app.config";

export default {
  page: {
    title: "Error 403",
    meta: [{ name: "description", content: appConfig.description }]
  }
}
</script>
<template>
  <div class="my-2 pt-2">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">
            <h1 class="display-2 font-weight-medium">
              4<i class="bx bx-buoy bx-spin text-primary display-3"></i>3
            </h1>
            <h4 class="text-uppercase">No tienes suficientes permisos para acceder a este contenido.</h4>
            <div class="mt-5 text-center">
              <router-link tag="a" class="btn btn-primary" to="/">Regresar</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col d-grid text-center">
            <img src="@/assets/images/empty_state_permission.svg" alt class="img-fluid img-error-empty-state p-5" />
        </div>
      </div>
  </div>
</template>

